import { render } from "./BrandCard.vue?vue&type=template&id=852c8430&scoped=true&ts=true"
import script from "./BrandCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandCard.vue?vue&type=script&setup=true&lang=ts"

import "./BrandCard.vue?vue&type=style&index=0&id=852c8430&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852c8430"],['__file',"resources/js/vue/domain/invoice/components/cards/BrandCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "852c8430"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('852c8430', __exports__)) {
    api.reload('852c8430', __exports__)
  }
  
  module.hot.accept("./BrandCard.vue?vue&type=template&id=852c8430&scoped=true&ts=true", () => {
    api.rerender('852c8430', render)
  })

}


export default __exports__